import { getCommonAxiosCommon } from 'app/helpers/MiscUtils';
import { JobFairBillingConfig, NgAPIResponse } from 'app/types';
import axios from 'axios';
import { config } from 'config';

export class JobFairBillingService {
  async getConfig (companyId: string): Promise<JobFairBillingConfig> {
    const result = await axios.get<NgAPIResponse<JobFairBillingConfig>>(
      `${config.vjfpNGRestAPI}/organizations/${companyId}/jobfair-billing`,
      await getCommonAxiosCommon()
    );
    return result.data.data;
  }
}
